import React from 'react';
import { CTAButton } from './CTAButton';
import { Reveal } from './Reveal';
import { CHECKOUT_LINKS } from '../utils/checkout';
type PricingCardsProps = {
  /** Anchor id for the highlighted plan — only set on the first (primary) pricing block. */
  highlightId?: string;
};
export function PricingCards({
  highlightId
}: PricingCardsProps) {
  return <div className="grid gap-5 md:grid-cols-2" data-id="element-134" data-mp="26c4lhewczb21">
      <Reveal data-id="element-135" data-mp="2be3qet7qyg13">
        <article className="flex h-full flex-col rounded-[2rem] border border-bark-800/10 bg-cream-50 p-7 shadow-sm sm:p-8" data-id="element-136" data-mp="2bc96ni87otyl">
          <h3 className="font-display text-xl font-semibold leading-snug text-bark-900" data-id="element-137" data-mp="2fd2te89x42pw">
            📘 KIT PADRES PRESENTES
          </h3>
          <p className="mt-1.5 text-sm font-medium text-bark-400" data-id="element-138" data-mp="2p4fiwt88ugsr">6 Tomos + 3 Bonos</p>
          <p className="mt-5 text-sm leading-relaxed text-bark-600" data-id="element-139" data-mp="2u3s6xhauptwx">
            <span className="font-semibold text-bark-800" data-id="element-140" data-mp="2u5mqosadzfzf">Ideal para:</span> padres y madres de hijos
            de 3 a 12 años
          </p>
          <p className="mt-auto pt-8 font-display text-4xl font-semibold text-bark-900" data-id="element-141" data-mp="3tgms7na1332i">
            $19.990 <span className="text-base font-medium text-bark-400" data-id="element-142" data-mp="3oi30f68r6x28">ARS</span>
          </p>
          <div className="mt-5" data-id="element-143" data-mp="3jiqhuxox0c5g">
            <CTAButton variant="secondary" href={CHECKOUT_LINKS.base} data-id="element-144" data-mp="3jjrsj120qwmn">
              → QUIERO MI KIT
            </CTAButton>
          </div>
        </article>
      </Reveal>

      <Reveal delay={0.08} data-id="element-145" data-mp="g1qg0ellwxq5">
        <article id={highlightId} className="relative flex h-full flex-col scroll-mt-24 rounded-[2rem] border-2 border-terracotta-500 bg-cream-50 p-7 shadow-warm-lg sm:p-8" data-id="element-146" data-mp="g0ygwtsswhv4">
          <span className="absolute -top-3.5 left-7 rounded-full bg-terracotta-500 px-4 py-1.5 text-[0.65rem] font-bold uppercase tracking-[0.15em] text-cream-50" data-id="element-147" data-mp="6b5a063lsqx7">
            Más elegido ⭐
          </span>
          <h3 className="mt-1 font-display text-xl font-semibold leading-snug text-bark-900" data-id="element-148" data-mp="ytatsah2z1ji">
            🏆 KIT + VACACIONES PRESENTES
          </h3>
          <p className="mt-1.5 text-sm font-medium text-bark-400" data-id="element-149" data-mp="2o9mycunh52zu">
            6 Tomos + 3 Bonos + Vacaciones Presentes
          </p>
          <p className="mt-5 text-sm leading-relaxed text-bark-600" data-id="element-150" data-mp="2t7ocd161mc4g">
            <span className="font-semibold text-bark-800" data-id="element-151" data-mp="2ek3a19gzsgxl">Ideal para:</span> quienes quieren extender
            el sistema a vacaciones y viajes en familia
          </p>
          <p className="mt-auto pt-8 font-display text-4xl font-semibold text-terracotta-600" data-id="element-152" data-mp="2jgtojsd5f4gw">
            $27.990 <span className="text-base font-medium text-bark-400" data-id="element-153" data-mp="25lhwxtuahu47">ARS</span>
          </p>
          <div className="mt-5" data-id="element-154" data-mp="2ag5bp0zhra5l">
            <CTAButton href={CHECKOUT_LINKS.completo} data-id="element-155" data-mp="1vl7jc84cekoi">→ QUIERO EL KIT COMPLETO</CTAButton>
          </div>
        </article>
      </Reveal>
    </div>;
}